import { useTranslations } from "next-intl";
import { usePagination } from "react-instantsearch";

function CatalogSearchResults() {
  const t = useTranslations("catalog");

  const { nbHits } = usePagination();

  if (!nbHits) return <></>;

  return <p className="pt-2 text-gray font-size-sm">{t("filters.results", { count: nbHits })}</p>;
}

export default CatalogSearchResults;
